<template>
  <div class="print-qrcode">
    <div class="bottom-title">
      <div class="bottom-text">打印水泵码</div>
    </div>
    <div class="submit-btn">
      <el-button style="margin-right: 10px;" type="primary" size="small" :loading="printLoading"
                 @click="onClickPrint">开始打印
      </el-button>
      <el-button style="margin-right: 20px;" type="primary" size="small" @click="onChangeStep">
        我的申请
      </el-button>
      <div class="submit-text" @mouseenter="onMouseEnter" @mouseleave="onMouseEnter">预览水泵码</div>
      <transition name="el-zoom-in-top">
        <el-image
            v-show="showPrintImg"
            class="submit-img"
            :src="companyInfo.qrContent"
            :preview-src-list="qrCodeList">
        </el-image>
      </transition>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            ref="refTable"
            @select-all="onChangeTableAll"
            @selection-change="onChangeTableSelection"
            :data="tableData"
            border>
          <el-table-column
              type="selection"
              align="center"
              width="45">
          </el-table-column>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="waterPumpCode"
              show-overflow-tooltip
              align="center"
              width="250"
              label="水泵码">
          </el-table-column>
          <el-table-column
              prop="enterpriseCode"
              show-overflow-tooltip
              align="center"
              label="企业码">
          </el-table-column>
          <el-table-column
              prop="productCode"
              show-overflow-tooltip
              align="center"
              label="产品码"
              width="120">
          </el-table-column>
          <el-table-column
              prop="serialNumber"
              show-overflow-tooltip
              align="center"
              label="序列号"
              width="100">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="创建时间"
              width="200">
          </el-table-column>

        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent"
            @size-change="onChangeSize"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            :page-sizes="[5, 20, 50, 100, 500]"
            layout="total, sizes, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <el-dialog
        title="水泵码打印信息"
        :destroy-on-close="true"
        :visible.sync="printDialogVisible"
        lock-scroll
        append-to-body
        width="300px">
      <div id="nbprint" style="color: black;padding: 0;">
        <div v-for="(item, index) in multipleSelection" :key="index"
             style="display: flex;justify-content: center;align-items: center;">
          <img title="水泵码" style="width: 92px;" :src="item.qrContent" alt="水泵码">
          <!--          <div>{{ item.waterPumpCode }}</div>-->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-print="printOption" type="primary" size="mini" :loading="printLoading">
          打印
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {getEnterprise, queryCodeTraceabilityTranslationList} from "../../utils/interface";

export default {
  components: {},
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      tableAllData: [],
      productData: {},
      queryParams: {
        enterpriseUuid: '',
        productCode: '',
        mainUuid: '',
        current: 1,
        pageSize: 5,
        total: 0,
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '已审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
      printLoading: false,
      qrCodeList: [],
      showPrintImg: false,
      companyInfo: {},
      printDialogVisible: false,
      printOption: {
        id: 'nbprint', // 打印元素的id 不需要携带#号
        preview: false, // 开启打印预览
        previewTitle: '', // 打印预览标题
        popTitle: '水泵码', // 页眉标题 默认浏览器标题 空字符串时显示undefined 使用html语言
        // 头部文字 默认空 在节点中添加 DOM 节点， 并用,(Print local range only)分隔多个节点
        extraHead: '',
        // 新的 CSS 样式表， 并使用,（仅打印本地范围）分隔多个节点
        extraCss: '',
        previewBeforeOpenCallback: () => {
          console.log("触发打印预览打开前回调");
        },
        previewOpenCallback: () => {
          console.log("触发打开打印预览回调");
        },
        beforeOpenCallback: () => {
          console.log("触发打印工具打开前回调");
        },
        openCallback: () => {
          console.log("触发打开打印工具回调");
        },
        closeCallback: () => {
          console.log("触发关闭打印工具回调");
        },
        clickMounted: () => {
          console.log("触发点击打印回调");
        }
      },
    };
  },
  created() {

  },
  methods: {
    initData(product) {
      this.productData = product
      this.queryParams.enterpriseUuid = product.enterpriseUuid
      this.queryParams.productCode = product.productCode
      this.queryParams.mainUuid = product.uuid
      this.getPageList()
      this.getCompanyEnterprise()
    },
    getPageList() {
      this.listLoading = true
      queryCodeTraceabilityTranslationList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getCompanyEnterprise() {
      getEnterprise().then((res) => {
        if (res.data) {
          this.companyInfo = res.data
          this.qrCodeList = [res.data.qrContent]
        }
      })
    },
    onClickPrint() {
      if (this.multipleSelection.length>0){
        this.printDialogVisible = true
      }else {
        this.$message.warning('请选择要打印的水泵码!')
      }
    },
    onChangeStep() {
      this.$emit('onChangeStep', 1)
      this.$emit('onChangeType', 1)
    },
    onChangeTableSelection(selection) {
      this.multipleSelection = selection
    },
    onChangeTableAll() {
      // this.$refs.refTable.clearSelection()
    },
    onMouseEnter() {
      this.showPrintImg = !this.showPrintImg
    },
    onInputChange() {
      this.$nextTick(() => {
        this.getPageList()
      })
    },
    onChangeCurrent(e) {
      this.queryParams.current = e
      this.getPageList()
    },
    onChangeSize(e) {
      this.queryParams.pageSize = e
      this.getPageList()
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  overflow-y: auto !important;
  height: 60vh !important;
}

/deep/ .el-card__body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.print-qrcode {
  .bottom-title {
    border-bottom: 1px solid #cccccc;
    padding-bottom: 20px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  .bottom-text {
    color: black;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 2px;
  }

  .submit-btn {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .submit-img {
    width: 120px;
    height: 120px;
    position: absolute;
    left: 300px;
    bottom: -70px;
    z-index: 9;
  }

  .submit-text {
    align-items: center;
    cursor: pointer;
  }

  .submit-text:hover {
    color: #409eff;
  }

  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 100px);
  }

  /deep/ .el-form--inline .el-form-item {
    width: 100%;
  }
}
</style>

<style media="print" scoped lang="less">

/*去除打印的页眉页脚*/
@page {
  size: auto;
  margin: 3mm;
}

</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoPrintQrcode.vue